/* unplugin-vue-components disabled */import { render } from "./unboxing.vue?vue&type=template&id=c930cfe8&scoped=true"
import script from "./unboxing.vue?vue&type=script&lang=js"
export * from "./unboxing.vue?vue&type=script&lang=js"

import "./unboxing.vue?vue&type=style&index=0&id=c930cfe8&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c930cfe8"]])

export default __exports__